import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ContractCard from './ContractCard';
import './HeroParallax.css';

const INITIAL_VISIBLE = 3;

const HeroParallax = ({ contracts = [] }) => {
    const [showAll, setShowAll] = useState(false);
    const [revealing, setRevealing] = useState(false);

    const firstRow = contracts.slice(0, INITIAL_VISIBLE);
    const secondRow = contracts.slice(INITIAL_VISIBLE, 6);
    const thirdRow = contracts.slice(6, 9);
    const remainingMobile = contracts.slice(INITIAL_VISIBLE);

    const hasMore = contracts.length > INITIAL_VISIBLE;

    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleReveal = () => {
        setRevealing(true);
        setTimeout(() => {
            setShowAll(true);
            setRevealing(false);
        }, 1400);
    };

    const revealVariants = {
        hidden: { opacity: 0, y: 60, scale: 0.94 },
        visible: (i = 0) => ({
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                delay: i * 0.08,
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
            },
        }),
    };

    return (
        <div className="hero-parallax-container">
            <div className="parallax-header">
                <h2>O Padrão Ouro em Investimentos</h2>
                <p>Segurança física com rendimento digital. Uma curadoria exclusiva da Golden Brasil.</p>
            </div>

            <div className="parallax-content">
                {isMobile ? (
                    <>
                        <div className="parallax-mobile-grid">
                            {firstRow.map((contract) => (
                                <ContractCard key={contract.id} contract={contract} />
                            ))}
                        </div>

                        <AnimatePresence>
                            {showAll && remainingMobile.length > 0 && (
                                <motion.div
                                    className="parallax-mobile-grid parallax-mobile-grid--revealed"
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {remainingMobile.map((contract, idx) => (
                                        <motion.div
                                            key={contract.id}
                                            custom={idx}
                                            variants={revealVariants}
                                        >
                                            <ContractCard contract={contract} />
                                        </motion.div>
                                    ))}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </>
                ) : (
                    <>
                        <div className="parallax-row">
                            {firstRow.map((contract) => (
                                <ContractCard key={contract.id} contract={contract} />
                            ))}
                        </div>

                        <AnimatePresence>
                            {showAll && (
                                <>
                                    {secondRow.length > 0 && (
                                        <motion.div
                                            className="parallax-row"
                                            initial="hidden"
                                            animate="visible"
                                        >
                                            {secondRow.map((contract, idx) => (
                                                <motion.div
                                                    key={contract.id}
                                                    custom={idx}
                                                    variants={revealVariants}
                                                    className="parallax-card-wrapper"
                                                >
                                                    <ContractCard contract={contract} />
                                                </motion.div>
                                            ))}
                                        </motion.div>
                                    )}
                                    {thirdRow.length > 0 && (
                                        <motion.div
                                            className="parallax-row"
                                            initial="hidden"
                                            animate="visible"
                                        >
                                            {thirdRow.map((contract, idx) => (
                                                <motion.div
                                                    key={contract.id}
                                                    custom={idx + secondRow.length}
                                                    variants={revealVariants}
                                                    className="parallax-card-wrapper"
                                                >
                                                    <ContractCard contract={contract} />
                                                </motion.div>
                                            ))}
                                        </motion.div>
                                    )}
                                </>
                            )}
                        </AnimatePresence>
                    </>
                )}
            </div>

            {hasMore && !showAll && (
                <div className="parallax-cta-wrapper">
                    <button
                        className={`parallax-cta ${revealing ? 'is-loading' : ''}`}
                        onClick={handleReveal}
                        disabled={revealing}
                    >
                        {revealing ? (
                            <span className="parallax-cta-loading">
                                <span className="parallax-loader" aria-hidden="true">
                                    <span className="parallax-loader-shape"></span>
                                </span>
                                <span>Carregando curadoria...</span>
                            </span>
                        ) : (
                            <>
                                <span>Veja nossa curadoria completa</span>
                                <svg className="parallax-cta-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <path d="M6 9l6 6 6-6" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default HeroParallax;
